export default __webpack_public_path__ + "3d07b3d6ddec29b50d0e8abea2b0f32b.png";